import { Styles } from '@chakra-ui/theme-tools';
import { Global } from '@emotion/react';
import React from 'react';

import { app } from './app';

export const GlobalStyles = () => {
    return (
        <Global styles={app} />
    );
};

export const styles: Styles = {
    global: () => ({
        ['svg, svg path']: {
            fill: 'var(--3p-colors-gray-400) !important',
            stroke: 'var(--3p-colors-gray-400) !important'
        }
    })
};
